import React, {useState} from 'react';
import { updateOperatorCurrentStatus } from "../../../../services/company/api";
import { t } from "../../../../components/Translate";
import DropdownSelect from "../../../../components-new/form/DropdownSelect";
import ColorIndicator from "../../../../components-new/general/ColorIndicator";
import './StatusSelect.css';

const StatusSelect = ({ user }) => {

    const statusOptions = [
        { value: 'AVAILABLE', label: t({ text: 'available', user }) },
        { value: 'PAUSE', label: t({ text: 'pause', user }) },
        { value: 'NOT_HERE', label: t({ text: 'not_here', user }) },
        { value: 'OFFLINE', label: t({ text: 'offline', user }) },
    ];

    const handleStatusChange = (newStatus) => {
        updateOperatorCurrentStatus(user.id, newStatus.value);
        setStatus(newStatus.value)
    };

    const [status, setStatus] = useState(user.currentStatus);

    /*
     * Sized by what is in it, as the header sheet has it. It was a 190px box,
     * which on a word as short as "Available" left most of the control empty.
     * The inset is the trigger's own padding now, so the indicator no longer
     * carries a margin of its own either.
     */
    return (
        <DropdownSelect
            options={statusOptions}
            selectedValue={status}
            onChange={handleStatusChange}
            classes="header-status-select"
            renderIndicator={(value) => <ColorIndicator currentStatus={value}/>}
            renderLabel={(value) => t({ text: value ? value.toLowerCase() : "", user })}
            styles={{width: 'auto', height: '36px'}}
        >
            {option => (
                <span className="header-status-option">
                    <ColorIndicator currentStatus={option.value}/>
                    <span className="header-status-option__label">{option.label}</span>
                </span>
            )}
        </DropdownSelect>
    );
};

export default StatusSelect;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/StatusSelect.jsx